import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BalancesComponent } from "./balance.component";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        MatProgressSpinnerModule
    ],
    declarations: [
        BalancesComponent,
    ],
    exports: [
        BalancesComponent,
    ]
})
export class BalanceModule { }